import { curvePreset } from './math/curve.js';
/**
 * Terse builders for authoring effect definitions in TypeScript (reference
 * effects, tests) and for the studio's "add layer/module" defaults.
 */
let idCounter = 0;
export function makeId(prefix = 'layer') {
    idCounter = (idCounter + 1) % 0xffff;
    return `${prefix}_${Date.now().toString(36)}${idCounter.toString(36)}`;
}
export const vConst = (value) => ({ type: 'constant', value });
export const vRange = (a, b) => ({ type: 'randomBetween', a, b });
export const vCurve = (curve, scale) => ({
    type: 'curve',
    curve: typeof curve === 'string' ? curvePreset(curve) : curve,
    ...(scale !== undefined ? { scale } : {}),
});
export const vCurveRandom = (curve, min, max) => ({
    type: 'curveRandom',
    curve: typeof curve === 'string' ? curvePreset(curve) : curve,
    min,
    max,
});
export const cConst = (value) => ({ type: 'constant', value });
export const cRange = (a, b) => ({ type: 'randomBetween', a, b });
/** Birth tint sampled from a gradient: stepped = discrete palette, smooth = spectrum. */
export const cGradient = (gradient, by) => ({
    type: 'gradient',
    gradient,
    ...(by ? { by } : {}),
});
export function gradient(mode, ...stops) {
    return { mode, stops: stops.map(([t, color]) => ({ t, color })) };
}
export function defaultLayer(partial) {
    return {
        id: makeId(),
        enabled: true,
        delay: 0,
        duration: 1,
        maxParticles: 256,
        emitter: {
            mode: { type: 'burst', count: 16 },
            shape: { type: 'point' },
            initial: {
                lifetime: vRange(0.4, 0.8),
                speed: vRange(1, 2),
                spread: vConst(0),
                size: vRange(0.15, 0.3),
                rotation: vConst(0),
                color: cConst([1, 1, 1, 1]),
            },
        },
        renderer: { type: 'billboard' },
        modules: [],
        material: { blend: 'additive', sprite: { type: 'procedural', hardness: 0.2 } },
        ...partial,
    };
}
export function defaultEffect(name = 'New Effect') {
    return {
        version: 1,
        meta: { name, duration: 1.5, loop: false, simulationSpace: 'local' },
        layers: [defaultLayer({ name: 'burst' })],
    };
}
